import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { setAnalysisBoxList } from '@reducers/keyword/keywordOptimizationSlice';
import { OptimizationTabObjList } from '@models/keyword/keyword';
import { fetchCompetitorBoxData } from '@reducers/keyword/thunk/optimizationThunk';
import SearchBox from './searchBox';
import AnalysisBox from './analysisBox';
import CompetitorBox from '../competitorBox';

const keywordOptimizationDescription = ({ selectedTab, tabTitle, tabText, limitLength, selectedGameInfo }) => {
  const dispatch = useDispatch<AppDispatch>();

  // useEffect for analysisBoxList 초기화 처리
  useEffect(() => {
    if (selectedTab === OptimizationTabObjList[3].value) {
      dispatch(setAnalysisBoxList({ data: null }));
      dispatch(fetchCompetitorBoxData({ userId: 'SS', tabType: selectedTab }));
    }
  }, [selectedTab]);

  return (
    <div className="chart-tab-conts active">
      {/* 검색부분 */}
      <SearchBox
        selectedAppObj={selectedGameInfo}
        tabType={selectedTab}
        limitLength={limitLength}
        placeHolder={'Insert Description Text'}
      />
      {/* 분석부분 */}
      <AnalysisBox />
      {/* 경쟁자키워드부분 */}
      <CompetitorBox />
    </div>
  );
};

export default keywordOptimizationDescription;
